var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenoit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 181 329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcdbbc;\n      }\n\n      .cls-2 {\n        fill: #3b271b;\n      }\n\n      .cls-3 {\n        fill: #4d3423;\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        fill: none;\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-8, .cls-9 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-8, .cls-12 {\n        stroke: #000d19;\n        stroke-width: 2px;\n      }\n\n      .cls-13 {\n        fill: #414a4c;\n      }\n\n      .cls-14 {\n        fill: #69392a;\n      }\n\n      .cls-15 {\n        fill: #eeb68c;\n      }\n\n      .cls-16 {\n        fill: #fce07d;\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-18 {\n        fill: #cca352;\n      }\n\n      .cls-5 {\n        stroke: #fff;\n        stroke-width: .5px;\n      }\n\n      .cls-19 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        stroke: #507e8f;\n        stroke-width: 3px;\n      }\n\n      .cls-20 {\n        fill: #8cbab7;\n      }\n\n      .cls-21 {\n        fill: #613c30;\n      }\n\n      .cls-22 {\n        fill: #1b526d;\n      }\n\n      .cls-7 {\n        stroke: #eeb68c;\n        stroke-width: 3.17px;\n      }\n\n      .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-linecap: round;\n      }\n\n      .cls-7, .cls-10, .cls-11, .cls-12 {\n        stroke-linejoin: round;\n      }\n\n      .cls-23 {\n        fill: #000d19;\n      }\n\n      .cls-24 {\n        fill: #361d16;\n      }\n\n      .cls-9 {\n        stroke: #cca352;\n      }\n\n      .cls-9, .cls-11 {\n        stroke-width: 1.42px;\n      }\n\n      .cls-25 {\n        fill: #052b33;\n      }\n\n      .cls-10 {\n        stroke-width: .71px;\n      }\n\n      .cls-10, .cls-11 {\n        stroke: #fce07d;\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-27 {\n        fill: #002131;\n      }\n\n      .cls-28 {\n        fill: #154259;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M74,69l-18.68-2.58c-3.86-.53-6.71,3.51-4.92,6.96l1.1,2.12c4.66,8.98,16.8,10.66,23.72,3.27l1.63-1.74c2.66-2.84,1.01-7.5-2.85-8.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M112.75,74.36l-18.68-2.58c-3.86-.53-6.71,3.51-4.92,6.96l1.1,2.12c4.66,8.98,16.8,10.66,23.72,3.27l1.63-1.74c2.66-2.84,1.01-7.5-2.85-8.03Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 71,
    cy: 299,
    rx: 49,
    ry: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91,
    y: 130.35,
    width: 17.42,
    height: 53.56,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(285.81 157.55) rotate(122.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.33,
    y: 137.44,
    width: 17.42,
    height: 53.56,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(275.54 8.14) rotate(81.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M70.02,128.98h27.98v22.92c0,7.72-6.27,13.99-13.99,13.99h0c-7.72,0-13.99-6.27-13.99-13.99v-22.92h0Z",
    transform: "translate(253.49 155.88) rotate(122.52)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.8,99.3h11.62v14.77c0,13.34-10.83,24.17-24.17,24.17h-10.06v-16.33c0-12.48,10.13-22.61,22.61-22.61Z",
    transform: "translate(16.62 -4.53) rotate(7.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.8,67.93h89.77v23.44c0,13.37-10.86,24.23-24.23,24.23h-41.3c-13.37,0-24.23-10.86-24.23-24.23v-23.44h0Z",
    transform: "translate(13.24 -9.21) rotate(7.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M52.61,265.26c-5.27,0-9.55-4.28-9.55-9.55v-46.75c0-5.27,4.28-9.55,9.55-9.55s9.55,4.28,9.55,9.55v46.75c0,5.27-4.28,9.55-9.55,9.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M43.06,302.46v-46.75c0-5.27,4.28-9.55,9.55-9.55s9.55,4.28,9.55,9.55v46.75h-19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M47.48,297.52h31.18v13.28h-26.73c-4.89,0-8.86-3.97-8.86-8.86h0c0-2.44,1.98-4.42,4.42-4.42Z",
    transform: "translate(121.71 608.33) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M71.71,252.16c5.27,0,9.55-4.28,9.55-9.55v-46.75c0-5.27-4.28-9.55-9.55-9.55-5.27,0-9.55,4.28-9.55,9.55v46.75c0,5.27,4.28,9.55,9.55,9.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M81.26,289.36v-46.75c0-5.27-4.28-9.55-9.55-9.55-5.27,0-9.55,4.28-9.55,9.55v46.75s19.1,0,19.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M66.58,284.43h31.18v13.28h-26.73c-4.89,0-8.86-3.97-8.86-8.86h0c0-2.44,1.98-4.42,4.42-4.42Z",
    transform: "translate(159.91 582.13) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M53.8,134.17h16.72c11.05,0,20.03,8.97,20.03,20.03v58.61h-56.77v-58.61c0-11.05,8.97-20.03,20.03-20.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.66,
    cy: 85.9,
    r: 11.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 40.53,
    cy: 76.23,
    r: 11.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.54,13.75h29.09c16.74,0,30.34,13.59,30.34,30.34v23.51c0,5.24-4.26,9.5-9.5,9.5H44.71c-5.24,0-9.5-4.26-9.5-9.5v-23.51c0-16.74,13.59-30.34,30.34-30.34Z",
    transform: "translate(6.96 -10.52) rotate(7.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.7,29.81h33.66c11.13,0,20.16,9.03,20.16,20.16v49.36c0,18.28-14.84,33.12-33.12,33.12h-7.75c-18.28,0-33.12-14.84-33.12-33.12v-49.36c0-11.13,9.03-20.16,20.16-20.16Z",
    transform: "translate(11.84 -10.11) rotate(7.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.62,115.16h19.09v19.22c0,5.27-4.28,9.54-9.54,9.54h0c-5.27,0-9.54-4.28-9.54-9.54v-19.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.61,108.03c-6.44,4.88-15.61,3.61-20.49-2.83"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M55.44,64.57h18.27c2.81,0,5.1,2.29,5.1,5.1v2.47h-28.47v-2.47c0-2.81,2.29-5.1,5.1-5.1Z",
    transform: "translate(9.95 -8.19) rotate(7.86)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M74,69l-18.68-2.58c-3.86-.53-6.71,3.51-4.92,6.96l1.1,2.12c4.66,8.98,16.8,10.66,23.72,3.27l1.63-1.74c2.66-2.84,1.01-7.5-2.85-8.03Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 60.53,
    y: 69.7,
    width: 13.79,
    height: 23.14,
    rx: 6.9,
    ry: 6.9,
    transform: "translate(123.12 171.01) rotate(-172.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 58.31,
    y: 74.85,
    width: 5.93,
    height: 10.81,
    rx: 2.96,
    ry: 2.96,
    transform: "translate(111 168.13) rotate(-172.14)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M94.18,69.93h18.27c2.81,0,5.1,2.29,5.1,5.1v2.47h-28.47v-2.47c0-2.81,2.29-5.1,5.1-5.1Z",
    transform: "translate(11.05 -13.43) rotate(7.86)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M112.75,74.36l-18.68-2.58c-3.86-.53-6.71,3.51-4.92,6.96l1.1,2.12c4.66,8.98,16.8,10.66,23.72,3.27l1.63-1.74c2.66-2.84,1.01-7.5-2.85-8.03Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 99.28,
    y: 75.06,
    width: 13.79,
    height: 23.14,
    rx: 6.9,
    ry: 6.9,
    transform: "translate(199.52 186.96) rotate(-172.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 97.06,
    y: 80.2,
    width: 5.93,
    height: 10.81,
    rx: 2.96,
    ry: 2.96,
    transform: "translate(187.4 184.08) rotate(-172.14)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M90.45,72.15c-.29-1.52-1.92-1.75-2.6-.36-2.69,5.43-7.21,13.75-8.34,21.98-.97,7.02,5.48,8.42,5.48,8.42,0,0,6.58.39,7.55-6.62,1.14-8.23-.96-17.47-2.08-23.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.37,124.24l-1.04,7.54c-1,7.27-7.71,12.34-14.97,11.34l-20.16-2.78c-7.27-1-12.34-7.71-11.34-14.97l1.04-7.54c.38-2.76,2.92-4.68,5.68-4.3l.87.12c1.76.24,2.99,1.86,2.74,3.62l-.67,4.86c-.37,2.65,1.49,5.09,4.13,5.46l18.79,2.59c2.65.37,5.09-1.49,5.46-4.13l.67-4.86c.24-1.76,1.86-2.99,3.62-2.74l.87.12c2.76.38,4.68,2.92,4.3,5.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "84.59 151.12 62 174.07 70.77 176.88 58.83 198.52 84.59 174.12 75.35 170.32 84.59 151.12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.06,78.49h20.47c1.94,0,3.52,1.58,3.52,3.52v4.44c0,2.93-2.38,5.31-5.31,5.31h-16.89c-2.93,0-5.31-2.38-5.31-5.31v-4.44c0-1.94,1.58-3.52,3.52-3.52Z",
    transform: "translate(12.65 -14.01) rotate(7.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.79,72.8h20.47c1.94,0,3.52,1.58,3.52,3.52v4.44c0,2.93-2.38,5.31-5.31,5.31h-16.89c-2.93,0-5.31-2.38-5.31-5.31v-4.44c0-1.94,1.58-3.52,3.52-3.52Z",
    transform: "translate(11.49 -8.42) rotate(7.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.61,81.59s2.66-3.14,7.48-2.47,6.54,4.4,6.54,4.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 122.19,
    y1: 85.04,
    x2: 125.68,
    y2: 85.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 50.31,
    y1: 75.12,
    x2: 53.67,
    y2: 75.58
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.87,120.93l-1.87,1.95c-.99,1.04-2.71.8-3.39-.47l-1.27-2.39c-.68-1.28.37-2.79,1.81-2.59l3.68.51c1.43.2,2.04,1.94,1.04,2.98Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 62.32,
    y1: 212.81,
    x2: 62.32,
    y2: 294.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.81,59.98h16.64c2.38,0,4.31,1.93,4.31,4.31v.92c0,1.23-1,2.22-2.22,2.22h-20.81c-1.23,0-2.22-1-2.22-2.22v-.92c0-2.38,1.93-4.31,4.31-4.31Z",
    transform: "translate(9.74 -14.46) rotate(7.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.03,54.62h16.64c2.38,0,4.31,1.93,4.31,4.31v.92c0,1.23-1,2.22-2.22,2.22h-20.81c-1.23,0-2.22-1-2.22-2.22v-.92c0-2.38,1.93-4.31,4.31-4.31Z",
    transform: "translate(8.65 -9.21) rotate(7.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.09,31.92h18.88v3.43h-15.45c-1.89,0-3.43-1.54-3.43-3.43h0Z",
    transform: "translate(5.57 -13.84) rotate(7.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.58,28.29h32.62v3.43h-36.05c0-1.89,1.54-3.43,3.43-3.43Z",
    transform: "translate(149.53 70.27) rotate(-172.14)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M171.32,128.62l-.63-9.32,2.22.8.84-2.36-3.99-1.44c-.69-.25-1.46-.1-2,.4l-14.85,13.42,1.64,8.31,16.78-9.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "152.91 130.12 99.88 172.79 102.37 185.6 154.54 138.43 158.64 139.91 157 131.6 152.91 130.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M72.25,236.93c1.31-.55,2.42-1.19,3.18-1.76,16.03-11.84,12.37-26.31,21.07-32.24,8.7-5.93,11.08-6.13,16.14-11.06,1.17-1.14,2.04-2.32,2.66-3.48l5.82,2.1,2.23-6.18-8.48-3.06v.02c-.27-.09-.56-.16-.89-.15-2.6.05-7.57,7.5-10.53-3.55-1.03-3.84-1.05-6.45-1.05-6.45,0,0-.19-3.31,1.33-6.82,1.67-3.86,3.32-6.05,3.37-9.27l2.83,1.02,1.76-4.88-8.1-2.92h0c-1.42-.61-3.21-.55-5.23.58-3.86,2.16-6.84,10.22-13.74,12.69-5.56,1.99-8.71-4.97-19.3,2.98-5.31,3.98-10.58,10.76-13.78,23.53-2.21,8.81-.33,17.84,1.18,26.51,1.67,9.62,1.67,15.74,6.67,20.76,1.08,1.09,2.27,1.81,3.5,2.26h0s8.1,2.92,8.1,2.92l1.28-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M74.73,240.45c-2.6,0-4.81-.9-6.58-2.67-3.93-3.94-4.63-8.52-5.69-15.46-.23-1.53-.48-3.17-.79-4.92l-.32-1.82c-1.42-8.04-2.88-16.35-.87-24.39,2.7-10.77,7.12-18.34,13.52-23.14,3.43-2.57,6.31-3.77,9.07-3.77,1.5,0,2.8.35,4.06.68,1.21.32,2.34.63,3.59.63.83,0,1.61-.14,2.39-.42,4.35-1.55,7.12-5.12,9.57-8.26,1.54-1.98,2.87-3.69,4.28-4.48,1.04-.58,2.04-.88,2.98-.88,2.59,0,4.16,2.27,4.55,4.52.57,3.22-.37,5.13-1.79,8.03-.42.85-.89,1.81-1.35,2.88-1.57,3.62-1.4,7-1.39,7.14,0,.08.03,2.71,1.07,6.6,1.18,4.43,2.89,6.58,5.21,6.58,1.43,0,2.78-.82,3.97-1.54.77-.47,1.56-.95,2.04-.96h0c.77,0,1.29.36,1.58,1.06.72,1.78-.23,5.35-3.43,8.47-3.04,2.96-5.1,4.19-8.22,6.04-1.98,1.17-4.44,2.63-7.82,4.94-3.91,2.67-5.41,6.88-7.15,11.76-2.31,6.49-4.94,13.84-13.94,20.49-1.44,1.07-4.87,2.87-8.55,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M109.94,152.26c2.33,0,3.53,2.12,3.85,3.93.53,2.99-.32,4.72-1.73,7.6-.42.86-.9,1.83-1.37,2.91-1.57,3.61-1.47,7.02-1.45,7.43,0,.34.09,2.99,1.1,6.78.47,1.76,1.9,7.11,5.9,7.11,1.63,0,3.13-.91,4.34-1.64.55-.34,1.39-.84,1.71-.85.33,0,.66.08.88.62.54,1.34-.11,4.61-3.27,7.69-2.98,2.9-5.01,4.11-8.09,5.94-1.98,1.18-4.45,2.65-7.86,4.97-4.1,2.8-5.64,7.11-7.42,12.11-2.28,6.39-4.86,13.64-13.69,20.16-1.37,1.02-4.63,2.73-8.12,2.73-2.4,0-4.45-.83-6.08-2.46-3.77-3.78-4.45-8.27-5.49-15.06-.24-1.56-.48-3.18-.79-4.94l-.32-1.83c-1.4-7.96-2.86-16.2-.88-24.1,2.66-10.61,7-18.04,13.26-22.74,3.3-2.48,6.05-3.63,8.65-3.63,1.41,0,2.66.34,3.88.66,1.2.32,2.43.65,3.77.65.91,0,1.77-.15,2.63-.46,4.54-1.62,7.51-5.43,9.89-8.49,1.43-1.84,2.78-3.57,4.07-4.29.93-.52,1.82-.78,2.63-.78M109.94,150.84c-1.01,0-2.13.3-3.32.97-3.86,2.16-6.84,10.22-13.74,12.69-.75.27-1.46.37-2.15.37-2.44,0-4.62-1.31-7.65-1.31-2.44,0-5.41.85-9.5,3.91-5.31,3.98-10.58,10.76-13.78,23.53-2.21,8.81-.33,17.84,1.18,26.51,1.67,9.62,1.67,15.74,6.67,20.76,2.12,2.13,4.64,2.88,7.09,2.88,3.69,0,7.21-1.71,8.97-3.01,16.03-11.84,12.37-26.31,21.07-32.24,8.7-5.93,11.08-6.13,16.14-11.06,5.03-4.9,4.8-10.75,1.4-10.75-.02,0-.03,0-.05,0-1.49.03-3.77,2.5-6,2.5-1.65,0-3.27-1.35-4.53-6.05-1.03-3.84-1.05-6.45-1.05-6.45,0,0-.19-3.31,1.33-6.82,2.01-4.63,3.98-6.86,3.2-11.32-.5-2.84-2.46-5.11-5.25-5.11h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "157 131.6 103.24 174.6 105.74 187.41 158.64 139.91 157 131.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M157,131.6l15.02-13.59c.98-.89,2.55-.25,2.64,1.07l.61,9.03c.08,1.22-.53,2.37-1.58,2.99l-15.06,8.8-1.64-8.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M84.75,219.53l-3.03-1.09c-.58-.21-1.36.49-1.75,1.56s-.23,2.1.36,2.31l3.03,1.09,1.39-3.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 84.05,
    cy: 221.46,
    rx: 2.06,
    ry: 1.12,
    transform: "translate(-152.79 225.45) rotate(-70.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M78.9,224.14l-3.03-1.09c-.58-.21-1.36.49-1.75,1.56s-.23,2.1.36,2.31l3.03,1.09,1.39-3.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 78.21,
    cy: 226.08,
    rx: 2.06,
    ry: 1.12,
    transform: "translate(-160.99 223.01) rotate(-70.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M86.41,226.52l-3.03-1.09c-.58-.21-1.36.49-1.75,1.56s-.23,2.1.36,2.31l3.03,1.09,1.39-3.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 85.71,
    cy: 228.46,
    rx: 2.06,
    ry: 1.12,
    transform: "translate(-158.28 231.64) rotate(-70.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M80.48,231.36l-3.03-1.09c-.58-.21-1.36.49-1.75,1.56-.39,1.07-.23,2.1.36,2.31l3.03,1.09,1.39-3.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 79.79,
    cy: 233.3,
    rx: 2.06,
    ry: 1.12,
    transform: "translate(-166.74 229.26) rotate(-70.18)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M173.25,122.35l-1.52-.55c-.29-.11-.69.24-.88.78s-.11,1.06.18,1.16l1.52.55.7-1.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 172.9,
    cy: 123.32,
    rx: 1.03,
    ry: 0.56,
    transform: "translate(-1.73 244.17) rotate(-70.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M170.32,124.66l-1.52-.55c-.29-.11-.69.24-.88.78s-.11,1.06.18,1.16l1.52.55.7-1.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 169.97,
    cy: 125.63,
    rx: 1.03,
    ry: 0.56,
    transform: "translate(-5.85 242.94) rotate(-70.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M166.81,127.52l-1.52-.55c-.29-.11-.69.24-.88.78s-.11,1.06.18,1.16l1.52.55.7-1.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 166.46,
    cy: 128.49,
    rx: 1.03,
    ry: 0.56,
    transform: "translate(-10.85 241.53) rotate(-70.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M167.12,132.41l-1.52-.55c-.29-.11-.69.24-.88.78s-.11,1.06.18,1.16l1.52.55.7-1.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 166.77,
    cy: 133.38,
    rx: 1.03,
    ry: 0.56,
    transform: "translate(-15.25 245.05) rotate(-70.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M173.84,127.65l-1.52-.55c-.29-.11-.69.24-.88.78s-.11,1.06.18,1.16l1.52.55.7-1.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 173.49,
    cy: 128.62,
    rx: 1.03,
    ry: 0.56,
    transform: "translate(-6.33 248.23) rotate(-70.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M170.87,130.08l-1.52-.55c-.29-.11-.69.24-.88.78s-.11,1.06.18,1.16l1.52.55.7-1.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 170.52,
    cy: 131.05,
    rx: 1.03,
    ry: 0.56,
    transform: "translate(-10.58 247.04) rotate(-70.18)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M88.68,205.02l13.95-11.75c.81-.68,1.95.28,1.42,1.19l-14.24,24.59c-.44.76-1.59.56-1.74-.31l-1.41-8.21c-.35-2.06.41-4.16,2.01-5.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "98.01 176.2 99.63 174.78 97.59 174.05 94.3 176.78 98.14 196.2 101.36 193.39 98.01 176.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "103.4 194.13 101.35 193.39 98.14 196.2 100.18 196.94 103.4 194.13"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "100.19 196.94 96.42 177.6 99.63 174.78 103.4 194.12 100.19 196.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 117.73,
    y1: 163.01,
    x2: 119.72,
    y2: 175.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 127.8,
    y1: 154.96,
    x2: 129.62,
    y2: 165.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 137.74,
    y1: 147,
    x2: 139.42,
    y2: 157.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 147.69,
    y1: 139.05,
    x2: 149.23,
    y2: 148.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 157.31,
    y1: 131.71,
    x2: 158.64,
    y2: 139.91
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 167.82,
    y1: 119.23,
    x2: 167.77,
    y2: 117.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 166.85,
    y1: 118.1,
    x2: 168.74,
    y2: 116.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 164.14,
    y1: 122.53,
    x2: 164.08,
    y2: 120.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 163.17,
    y1: 121.4,
    x2: 165.05,
    y2: 119.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 160.32,
    y1: 125.93,
    x2: 160.27,
    y2: 124.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 159.35,
    y1: 124.8,
    x2: 161.23,
    y2: 123.1
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 80.92,
    y1: 195.8,
    x2: 165.74,
    y2: 126.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "81.48 197.72 157.82 134.84 168.75 125.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "82.07 199.43 158.04 136.21 172.32 123.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "82.64 200.82 158.25 137.5 172.48 126.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "82.89 202.65 158.42 138.55 170.16 129.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 83.55,
    y1: 204.47,
    x2: 165.53,
    y2: 134.03
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "79.4 190.9 81.03 189.38 78.89 188.68 75.58 191.61 80.19 211.59 83.42 208.57 79.4 190.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "85.56 209.27 83.42 208.57 80.19 211.59 82.33 212.28 85.56 209.27"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "82.33 212.28 77.8 192.4 81.03 189.38 85.56 209.26 82.33 212.28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.39,
    y: 160,
    width: 17.42,
    height: 53.56,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(-49.17 19.64) rotate(-15.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.33,
    y: 176.37,
    width: 17.42,
    height: 53.56,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(-129.85 283.65) rotate(-93.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 86.95,
    cy: 196.21,
    r: 14.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M41.33,150.5h0c7.72,0,13.99,6.27,13.99,13.99v22.92h-27.98v-22.92c0-7.72,6.27-13.99,13.99-13.99Z",
    transform: "translate(-44.49 17.66) rotate(-15.82)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 151.44,
    cy: 155.81,
    r: 14.42
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenoit2);
export default __webpack_public_path__ + "static/media/benoit_2.979a0432d3a81b5fe3e60aa573f6a08d.svg";
export { ForwardRef as ReactComponent };